/**
 * Gives back a timestamp in milliseconds taking into account the primary accounts selected tz
 */
import m from 'moment-timezone';
import Radio from 'backbone.radio';
var globalCh = Radio.channel('global');

 function date_milli_UTC(ts, tz) {
    if (!tz) {
        let primary = globalCh.request('primary_account');
        tz = primary.get_timezone();
    }

    let mts = m(ts).tz(tz);
    return mts.format('YYYY-MM-DDTHH:mm:ss.SSS Z');
 }

 export default date_milli_UTC;